import Link from "next/link";

import type { Keyword } from "@/types";
import { sanitizePathSegment } from "@/lib/utils";

type Props = { keyword: Keyword };
export default function KeywordLink({ keyword: { _id, name, slug } }: Props) {
	const pathSegment = slug ? sanitizePathSegment(slug) || _id : _id;

	return (
		<Link
			key={_id}
			href={`/blogs/keywords/${pathSegment}`}
			className="inline-flex h-8 items-center justify-center rounded-full bg-secondary/[0.02] px-4 text-xsm2 text-secondary transition-colors hover:bg-secondary/5"
		>
			{name}
		</Link>
	);
}
